import { v4 as uuidv4 } from 'uuid'

export const getInitialQAItemData = () => ({
  question: '',
  answer: '',
  clientId: uuidv4(),
})
